import CustomHiringProcess from './CustomHiringProcess/CustomHiringProcess';
import React, { useState } from 'react';

import Select from 'react-select';
import { postHiring, getHiringTeam, directory, deleteInterview, removeHiringTeam, sendMail } from '../service/RecruiterApi';

import { useEffect } from 'react';

function HiringProcess(props) {
    let empDetails = {
        emp_name: '',
        emp_id: '',
        email: '',
    };
    let jobTitle = props.job;
    let Domain = props.department;

    const [showInput, setShowInput] = useState({
        hiringManager: false,
        recruiter: false,
        panelMembers: false,
    });
    const [addButton, setaddButton] = useState(true);
    const [showEmployee, setShowEmployee] = useState(true);
    const [selectedPeopleList, setSelectedPeopleList] = useState(true);
    const [selectedPeopleList1, setSelectedPeopleList1] = useState(true);
    const [selectedPeopleList2, setSelectedPeopleList2] = useState(true);

    const [PanelShown, setIsPanelShown] = useState(false);
    const [emp, setEmp] = useState(true);
    const [selectedlistvalidation, setselectedListValidation] = useState(true);

    const [inputForm, setInputForm] = useState({
        hiringManager: '',
        recruiter: '',
        panelMembers: '',
    });

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let obj = {
    //     name: '',
    //     id: '',
    // };
    const [hiringManager, setHiringManager] = useState([]);
    const [hiringManagerid, setHiringManagerId] = useState([]);
    const [isShown, setIsShown] = useState(false);
    const [isrecShown, setIsrecShown] = useState(false);
    const [ispanelShown, setIspanelShown] = useState(false);
    const [recruiter, setRecruiter] = useState([]);
    const [panelMember, setPannelMember] = useState([]);
    const [recruiterID, setRecruiterID] = useState([]);
    const [panelMemberID, setPannelMemberID] = useState([]);
    useEffect(() => {
        //
        getHiringPanel();
    }, []);
    const getHiringPanel = async() => {
        try {
            let data = {
                job_id: params.id,
            };
            bind('value');
            let res=await getHiringTeam(data)
                if (res.data.statusCode == 200) {
                    let hiring = [];
                    let rec = [];
                    let pm = [];
                    let hiringId = [];
                    let recId = [];
                    let pmId = [];

                    res.data.data.map((value) => {
                        if (value.type === 'hiringManager') {
                            hiring.push(value.emp_name);
                            hiringId.push(value.id);
                            // setHiringManager((hiringManager) => [...hiringManager, value.emp_name]);
                            // setHiringManagerId((hiringManagerID) => [...hiringManagerID, value.id]);
                        } else if (value.type === 'panelMembers') {
                            pm.push(value.emp_name);
                            pmId.push(value.id);
                            // setPannelMember((panelMembers) => [...panelMembers, value.emp_name]);
                            // setPannelMemberID((panelMembersID) => [...panelMembersID, value.id]);
                        } else if (value.type == 'recruiter') {
                            rec.push(value.emp_name);
                            recId.push(value.id);
                            // setRecruiter((recruiter) => [...recruiter, value.emp_name]);
                            // setRecruiterID((recruiterID) => [...recruiterID, value.id]);
                        }
                    });
                    setRecruiter(rec);
                    setRecruiterID(recId);
                    setPannelMember(pm);
                    setPannelMemberID(pmId);
                    setHiringManager(hiring);
                    setHiringManagerId(hiringId);
                }
    
        } catch (err) {
            throw err;
        }
    };

    const updateInterviewers = (e, value) => {
        setInputForm((inputForm) => ({
            ...inputForm,
            [value]: e.username,
        }));
    };
    const bind = async (value) => {
        let empResult;
        if (value === 'team') {
            empResult = await directory({ domain: 'domain' });
        } else {
            empResult = await directory({});
        }

        let samplearray = [];

        let temparray = empResult.data?.ResponseData.emplist;

        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                email_id: temparray[i].email_id,

                img: '/Images/logo-person-user-person-icon.jpg',
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };

            samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
    };

    const handleChange = (e, value) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        setSelectedPeopleList(selectedValue);
        setEmp(attend);
        if (e != null) {
            updateInterviewers(e, value);
        }
    };
    const handlerecChange = (e, value) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        setSelectedPeopleList1(selectedValue);
        setEmp(attend);
        if (e != null) {
            updateInterviewers(e, value);
        }
    };
    const handlepanChange = (e, value) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        setSelectedPeopleList2(selectedValue);
        setEmp(attend);
        if (e != null) {
            updateInterviewers(e, value);
        }
    };
    const handleShowInput = async(e, value) => {
        if (e.keyCode === 13) {
            if (selectedPeopleList.value !== '' && selectedPeopleList.value !== undefined && value === 'hiringManager') {
                let data = {
                    jobID: params.id,
                    emp_id: selectedPeopleList.value,
                    type: value,
                };

                postHiring(data).then((res) => {
                    if (res.data.statusCode == 200) {
                        getHiringPanel();
                    }
                });
                if (value === 'hiringManager') {
                    setShowInput((showInput) => ({
                        ...showInput,
                        hiringManager: false,
                    }));
                    //setHiringManager((hiringManager) => [...hiringManager, selectedPeopleList.label]);
                }
            }
            if (selectedPeopleList2.value !== '' && selectedPeopleList2.value !== undefined && value === 'panelMembers') {
                let data = {

                    jobID: params.id,
                    emp_id: selectedPeopleList2.value,
                    type: value,
                };

                let res=await postHiring(data)
                    if (res.data.statusCode == 200) {
                        getHiringPanel();
                        let content = {
                            Subject: `Invitation to Join AVASOFT Recruitment Panel`,
                            body: `<html lang="en">
    
                            <head>
                              <meta charset='utf-8'>
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Invite User</title>
                            </head>
                            
                            <body>
                              <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                               <div style="background-color:#ffffff; width: 100%;">
                                <div style="padding: 15px 32px; background-color: #ffffff;">
                                 <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                                </div>
                               </div>
                            
                               <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                               <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style=" font-size: 20px; color: #F29B10;">
                                Hi ${selectedPeopleList2.username},
                                </h3>
                                <p style=" font-size: 16px; color: #0f0f0f;">
                                This is to inform you to join our AVASOFT recruitment panel. We will share more details soon. You are required to access the candidate information through the HIVE portal. Reach out to HR Team if you have any queries. <br/><br/>
        
                              Thanks for your support! <br/><br/>
                              Please click in the following link: <a href="https://hive.avasoft.com">https://hive.avasoft.com</a>  
                              </p>
                              <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                               Yours Truly,
                               </p>
                              <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                               Team Avasoft
                               </p>
                               </div>
                              </div>
                              
                            </div>
                            </body>
                            </html>`,
                            to: [selectedPeopleList2.email_id],
                        };
                        // let content = emailContents.PanelMemberEmail;
                        // let body = content.body;
                        // body.replace('PanelMemberName', 'Ram Vashakan');
                        // content = { ...content, body,  };

                        sendMail(content);
                    }
         
                if (value === 'panelMembers') {
                    setShowInput((showInput) => ({
                        ...showInput,
                        panelMembers: false,
                    }));
                    let content = {
                        Subject: `Invitation to Join AVASOFT Recruitment Panel`,
                        body: `<html lang="en">
    
                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>
                        
                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                           </div>
                        
                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Hi ${selectedPeopleList2.username},
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            This is to inform you to join our AVASOFT recruitment panel. We will share more details soon. You are required to access the candidate information through the HIVE portal. Reach out to HR Team if you have any queries. <br/><br/>

                      Thanks for your support! <br/><br/>
                      Please click in the following link: <a href="https://hive.avasoft.com">https://hive.avasoft.com</a>  
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>
                          
                        </div>
                        </body>
                        </html>`,
                        to: [selectedPeopleList2.email_id],
                    };
                    // let content = emailContents.PanelMemberEmail;
                    // let body = content.body;
                    // body.replace('PanelMemberName', 'Ram Vashakan');
                    // content = { ...content, body,  };

                    sendMail(content);
                    //setPannelMember((panelMembers) => [...panelMembers, selectedPeopleList2.label]);
                }
            }
            if (selectedPeopleList1.value !== '' && selectedPeopleList1.value !== undefined && value == 'recruiter') {
                let data = {
                    jobID: params.id,
                    emp_id: selectedPeopleList1.value,
                    type: value,
                };

                postHiring(data).then((res) => {
                    if (res.data.statusCode == 200) {
                        getHiringPanel();
                    }
                });
                if (value == 'recruiter') {
                    setShowInput((showInput) => ({
                        ...showInput,
                        recruiter: false,
                    }));
                    // setRecruiter((recruiter) => [...recruiter, selectedPeopleList1.label]);
                }
            }
        }
        setSelectedPeopleList([]);
        setSelectedPeopleList1([]);
        setSelectedPeopleList2([]);
    };
    let removeRound = async (i, id, val) => {
        try {
            if (val == 'Hiring') {
                let arr = hiringManager;
                let removed = arr.splice(i, 1);
            } else if (val == 'recruiter') {
                let arr = recruiter;
                let removed = arr.splice(i, 1);
            } else if (val == 'Panel') {
                let arr = panelMember;
                let removed = arr.splice(i, 1);
            }

            let data = { id: id };
            let deletedvalue = await removeHiringTeam(data);
        } catch (e) {
            throw e;
        }
    };

    return (
        <div className="tab-pane fade" id="hiringprocess" role="tabpanel" aria-labelledby="hiringprocess-tab">
            <CustomHiringProcess />
            <div className="mt-3">
                <div className="bg-white col-md-12 p-4">
                    <h1 className="bold-text font-16 label-color">Hiring Workflow</h1>
                    <p className="font-14 semibold-text hiring-para-label">
                        Configure the different stages involved in selecting the right candidate for this job
                    </p>
                    <button
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRight"
                        aria-controls="offcanvasRight"
                        className="font-15 bold-text custom-hiring-btn"
                    >
                        Manage Hiring Stages
                    </button>
                </div>
            </div>
            <div className="mt-3">
                <div className="bg-white col-md-12 p-4">
                    <h1 className="bold-text font-16 label-color">Hiring Team</h1>
                    <div className="row">
                        <h2 className="semibold-text font-14 hiring-para-label mt-3">Hiring Manager(s)</h2>
                        <div className="row align-items-center">
                            {hiringManager.length > 0 &&
                                hiringManager.map((obj, i) => {
                                    return (
                                        <div className="col-md-3 mt-2">
                                            <div
                                                className="d-flex"
                                                onMouseEnter={() => setIsShown(true)}
                                                onMouseLeave={() => setIsShown(false)}
                                            >
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    alt="profile-img"
                                                    className="profile-image"
                                                />
                                                <div className="ms-2 ps-2">
                                                    <p className="mb-0 font-11 semibold-text text-decoration-none profile-label-color">
                                                        {obj}
                                                    </p>
                                                    <p className="mb-0 font-11 semibold-text dropdown-sublabel-color">Hiring Manager</p>
                                                </div>
                                                {isShown ? (
                                                    <span className="cursor-pointer">
                                                        <img
                                                            src="/Images/hiring-stage-remove.svg"
                                                            alt="Hiring Stage Remove"
                                                            onClick={() => {
                                                                removeRound(i, hiringManagerid[i], 'Hiring');
                                                            }}
                                                        />
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            {!showInput.hiringManager && (
                                <div className="col-md-3">
                                    <a
                                        className="text-decoration-none font-11 semibold-text profile-label-color"
                                        onClick={() => {
                                            setShowInput((showInput) => ({
                                                ...showInput,
                                                hiringManager: true,
                                            }));
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/Add Button.svg" className="me-2" />
                                        </span>
                                        Add Hiring Manager(s)
                                    </a>
                                </div>
                            )}
                            {showInput.hiringManager && (
                                <div className="col-md-3">
                                    <Select
                                        className="dropdown"
                                        name="hiringManager"
                                        maxMenuHeight={150}
                                        placeholder="Select attendees"
                                        value={selectedPeopleList}
                                        options={showEmployee} // set list of the data
                                        onChange={(e) => {
                                            setselectedListValidation('');
                                            handleChange(e, 'hiringManager');
                                        }}
                                        onKeyDown={(e) => {
                                            handleShowInput(e, 'hiringManager');
                                        }}
                                        isClearable
                                    />
                                </div>
                            )}
                        </div>
                        <h2 className="semibold-text font-14 hiring-para-label mt-4">Recruiter(s)</h2>
                        <div className="row align-items-center">
                            {recruiter.length > 0 &&
                                recruiter.map((obj, i) => {
                                    return (
                                        <div className="col-md-3 mt-2">
                                            <div
                                                className="d-flex"
                                                onMouseEnter={() => setIsrecShown(true)}
                                                onMouseLeave={() => setIsrecShown(false)}
                                            >
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    alt="profile-img"
                                                    className="profile-image"
                                                />
                                                <div
                                                    className="ms-2 ps-2"
                                                    // onMouseEnter={() => setIsShown(true)}
                                                    // onMouseLeave={() => setIsShown(false)}
                                                >
                                                    <p className="mb-0 font-11 semibold-text text-decoration-none profile-label-color">
                                                        {obj}
                                                    </p>
                                                    <p className="mb-0 font-11 semibold-text dropdown-sublabel-color">HR Recruiter</p>
                                                </div>
                                                {isrecShown ? (
                                                    <span className="cursor-pointer">
                                                        <img
                                                            src="/Images/hiring-stage-remove.svg"
                                                            alt="Hiring Stage Remove"
                                                            onClick={() => {
                                                                removeRound(i, recruiterID[i], 'recruiter');
                                                            }}
                                                        />
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            {!showInput.recruiter && (
                                <div className="col-md-3">
                                    <a
                                        onClick={() => {
                                            setShowInput((showInput) => ({
                                                ...showInput,
                                                recruiter: true,
                                            }));
                                        }}
                                        className="text-decoration-none font-11 semibold-text profile-label-color"
                                    >
                                        <span>
                                            <img src="/Images/Add Button.svg" className="me-2" />
                                        </span>
                                        Add Recruiter(s)
                                    </a>
                                </div>
                            )}
                            {showInput.recruiter && (
                                <div className="col-md-3">
                                    <Select
                                        className="dropdown"
                                        name="hiringManager"
                                        maxMenuHeight={150}
                                        placeholder="Select attendees"
                                        value={selectedPeopleList1}
                                        options={showEmployee} // set list of the data
                                        onChange={(e) => {
                                            setselectedListValidation('');
                                            handlerecChange(e, 'recruiter');
                                        }}
                                        onKeyDown={(e) => {
                                            handleShowInput(e, 'recruiter');
                                        }}
                                        isClearable
                                    />
                                    {/* <input
                    type="search"
                    onKeyDown={(e) => {
                      handleShowInput(e, "recruiter");
                    }}
                    onChange={(e) => {
                      updateInterviewers(e);
                    }}
                    name="recruiter"
                    className="search-group form-control custom-textfield p-2"
                  /> */}
                                </div>
                            )}
                        </div>
                        <h2 className="semibold-text font-14 hiring-para-label mt-4">Panel Member(s)</h2>
                        <div className="row align-items-center">
                            {panelMember.length > 0 &&
                                panelMember.map((obj, i) => {
                                    return (
                                        <div className="col-md-3 mt-2">
                                            <div
                                                className="d-flex"
                                                onMouseEnter={() => setIsPanelShown(true)}
                                                onMouseLeave={() => setIsPanelShown(false)}
                                            >
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    alt="profile-img"
                                                    className="profile-image"
                                                />
                                                <div className="ms-2 ps-2">
                                                    <p className="mb-0 font-11 semibold-text text-decoration-none profile-label-color">
                                                        {obj}
                                                    </p>
                                                    <p className="mb-0 font-11 semibold-text dropdown-sublabel-color">Panel Member</p>
                                                </div>
                                                {PanelShown ? (
                                                    <span className="cursor-pointer">
                                                        <img
                                                            src="/Images/hiring-stage-remove.svg"
                                                            alt="Hiring Stage Remove"
                                                            onClick={() => {
                                                                removeRound(i, panelMemberID[i], 'Panel');
                                                            }}
                                                        />
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            {!showInput.panelMembers && (
                                <div className="col-md-3">
                                    <a
                                        onClick={() => {
                                            setShowInput((showInput) => ({
                                                ...showInput,
                                                panelMembers: true,
                                            }));
                                        }}
                                        className="text-decoration-none font-11 semibold-text profile-label-color"
                                    >
                                        <span>
                                            <img src="/Images/Add Button.svg" className="me-2" />
                                        </span>
                                        Add Panel Member(s)
                                    </a>
                                </div>
                            )}
                            {showInput.panelMembers && (
                                <div className="col-md-3">
                                    <Select
                                        className="dropdown"
                                        name="hiringManager"
                                        maxMenuHeight={150}
                                        placeholder="Select attendees"
                                        value={selectedPeopleList2}
                                        options={showEmployee} // set list of the data
                                        onChange={(e) => {
                                            setselectedListValidation('');
                                            handlepanChange(e, 'panelMembers');
                                        }}
                                        onKeyDown={(e) => {
                                            handleShowInput(e, 'panelMembers');
                                        }}
                                        isClearable
                                    />
                                    {/* <input
                    onChange={(e) => {
                      updateInterviewers(e);
                    }}
                    onKeyDown={(e) => {
                      handleShowInput(e, "pannelMembers");
                    }}
                    type="search"
                    name="panelMembers"
                    className="search-group form-control custom-textfield p-2"
                  /> */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default HiringProcess;
